import { cn } from "../../lib/utils";

interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "accent" | "success" | "warning" | "error" | "info";
  className?: string;
}

const v: Record<NonNullable<BadgeProps["variant"]>, string> = {
  default: "bg-white/[0.06] text-[var(--color-text-secondary)] ring-white/[0.04]",
  accent: "bg-[#266DF0]/10 text-[#5B8DF4] ring-[#266DF0]/10",
  success: "bg-emerald-500/10 text-emerald-400 ring-emerald-500/10",
  warning: "bg-amber-500/10 text-amber-400 ring-amber-500/10",
  error: "bg-red-500/10 text-red-400 ring-red-500/10",
  info: "bg-sky-500/10 text-sky-400 ring-sky-500/10",
};

export function Badge({ children, variant = "default", className }: BadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center rounded-[5px] px-[6px] py-[1px] text-[11px] leading-[16px] font-medium ring-1 ring-inset",
      v[variant], className
    )}>
      {children}
    </span>
  );
}
